<ngx-charts-bubble-chart *ngIf="init" [view]="chartOptions.view" [scheme]="chartOptions.colorScheme"
  [results]="data.data" [xAxis]="chartOptions.showXAxis" [yAxis]="chartOptions.showYAxis"
  [legend]="chartOptions.showLegend" [showXAxisLabel]="chartOptions.showXAxisLabel"
  [showYAxisLabel]="chartOptions.showYAxisLabel" [xAxisLabel]="chartOptions.xAxisLabel"
  [yAxisLabel]="chartOptions.yAxisLabel" [xScaleMin]="chartOptions.xScaleMin" [xScaleMax]="chartOptions.xScaleMax"
  [yScaleMin]="chartOptions.yScaleMin" [yScaleMax]="chartOptions.yScaleMax" [minRadius]="chartOptions.minRadius"
  [maxRadius]="chartOptions.maxRadius" (select)="onSelect($event)" (activate)="onActivate($event)"
  (deactivate)="onDeactivate($event)">
</ngx-charts-bubble-chart>